$(function() {
  'use strict';

  var runtime = false;


  // 通報ボタン押下
  $('.btn-increment-meta').one('click',  function(event) {
    event.preventDefault();

    var repBtn = $(this);
    repBtn.prop('disabled', true);
    repBtn.addClass('disabled');

    $.ajax({
      url: moko.ajaxurl,
      type: 'POST',
      dataType: 'text',
      timeout: 10000,
      cache : false,
      data: {
        'action': 'moko_increment_meta',
        '_ajax_nonce': repBtn.data('nonce'),
        'id': repBtn.data('post-id'),
        'key': repBtn.data('meta-key'),
        'current' : repBtn.data('current')
      }
    }).
      always(function() {
        //repBtn.prop('disabled', false);
      }).
        fail(function(xhr, status, error) {
          console.log('failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
          alert('通信エラー');
        }).
          done(function(data) {
            console.log( 'result', data );
            if (data === 'OK') {
              alert('投票ありがとうございます！');
            } else if (data === 'Existing') {
              alert('既に投票ずみです');
            } else {
              alert('送信に失敗しました');
              //repBtn.prop('disabled', false);
            }
          });
  });
});
